import { tags } from "../constants";
import {
  commonTransform,
  commonTransformWithDetails,
} from "../handleTransformation";
import {
  ADD_BULK_CANDIDATES_FROM_CSV_URL,
  ADD_CANDIATE_URL,
  CANDIDATE_CONFIDENCE_SCORE,
  CANDIDATE_CONVERTED_STATUS,
  CANDIDATE_ENGAGEMENT_SCORE,
  CREATE_CANDIDATE_CALL_HISTORY_URL,
  GET_CANDIDATE_CALL_HISTORY_URL,
  UPDATE_CANDIDATE_CALL_HISTORY_URL,
  GET_CANDIDATE_TOUCHPOINT_INSTANCES,
  GET_CANDIDATES_TASK_ERRORS,
  VALIDATE_CANDIDATES_FROM_CSV_URL,
} from "services/url.service";

export const candidateMutations = {
  validateCandidatesFromCSV: {
    getUrl: (companyId) => VALIDATE_CANDIDATES_FROM_CSV_URL(companyId),
    transformResponse: (res) => commonTransformWithDetails(res),
    method: "POST",
  },
  addCandidatesFromCSV: {
    getUrl: (companyId) => ADD_BULK_CANDIDATES_FROM_CSV_URL(companyId),
    transformResponse: (res) => commonTransformWithDetails(res),
    method: "POST",
    invalidatesTags: [tags.CANDIDATES],
  },
  createCallHistory: {
    getUrl: (params) => CREATE_CANDIDATE_CALL_HISTORY_URL(params.candidateId),
    transformResponse: (res) => res,
    method: "PUT",
  }, 
  updateCallHistory: {
    getUrl: (params) => UPDATE_CANDIDATE_CALL_HISTORY_URL(params.callSid),
    transformResponse: (res) => res,
    method: "POST",
  },
};


export const candidateQueries = {
  getCandidateConfidenceScore: {
    getUrl: ({ companyId }) => {
      return CANDIDATE_CONFIDENCE_SCORE(companyId);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getCandidateConvertedStatus: {
    getUrl: ({ filters, companyId }) => {
      return CANDIDATE_CONVERTED_STATUS({ companyId, filters });
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getCandidatesAverageEngagementScore: {
    getUrl: ({ companyId, filters, offerAccepted }) => {
      return CANDIDATE_ENGAGEMENT_SCORE({ companyId, filters, offerAccepted });
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getCandidates: {
    getUrl: ({ search, offset, sort, filters, companyId, fetchAll }) => {
      return ADD_CANDIATE_URL(
        companyId,
        search,
        offset,
        sort,
        filters,
        fetchAll
      );
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.CANDIDATES],
  },
  getCallHistory: {
    getUrl: ({ candidateId }) =>
      GET_CANDIDATE_CALL_HISTORY_URL({ candidateId }),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
  getCandidateTouchPointInstances: {
    getUrl: ({
      candidateId,
      search,
      touchPointStatus,
      offset,
      sort,
      limit,
      isEmployee,
    }) => {
      return GET_CANDIDATE_TOUCHPOINT_INSTANCES(
        candidateId,
        search,
        touchPointStatus,
        offset,
        sort,
        limit,
        isEmployee
      );
    },
    transformResponse: (res) => commonTransform(res),
    providesTags: [tags.EMPLOYEES,tags.TOUCH_POINT_INSTANCE],
    method: "GET",
  },
  getCandidateTaskErrors:{
    getUrl: ({candidateId, search, offset, sort, isEmployee}) => {
      return GET_CANDIDATES_TASK_ERRORS(candidateId, search, offset, sort, isEmployee);
    },
    transformResponse: (res) => commonTransform(res),
    providesTags: [tags.EMPLOYEES],
    method: "GET",
  },
};
